import _ from 'lodash';

const groupPrices = (sizes, pricesForSizes) => sizes.reduce((toReturn, current) => {
  const nextToReturn = { ...toReturn };
  const index = pricesForSizes[current].unitPrice;
  const value = pricesForSizes[current];
  if (!nextToReturn[index]) {
    nextToReturn[index] = {
      title: current,
      value,
    };
  } else {
    const titlePart = String(nextToReturn[index].title).split('-')[0];
    nextToReturn[index] = {
      value,
      title: `${titlePart}-${current}`,
    };
  }
  return nextToReturn;
}, {});

const mapAsTitleValue = (groupedPrices) => {
  const mappedAsTitleValue = {};
  _.values(groupedPrices).forEach((v) => {
    if (v) {
      mappedAsTitleValue[v.title] = v.value;
    }
  });
  return mappedAsTitleValue;
};

export const getProductPriceSummary = ({ sizes, pricesForSizes }) => {
  if (!sizes || !pricesForSizes) return {};

  const groupedPrices = groupPrices(sizes, pricesForSizes);

  return mapAsTitleValue(groupedPrices);
};
